import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { Share2 } from "lucide-react";
import { toast } from "sonner";
import SocialPublish from "../components/SocialPublish";

export default function Publish() {
  const [params, setParams] = useSearchParams();
  useEffect(() => {
    if (params.get("connected")) toast.success("Compte connecté ✅");
    if (params.get("error")) toast.error("La connexion a échoué. Réessayez.");
    if (params.get("connected") || params.get("error")) setParams({}, { replace: true });
  }, [params, setParams]);

  return (
    <div className="space-y-6" data-testid="publish-page">
      <div>
        <h1 className="font-display text-3xl font-extrabold flex items-center gap-2">
          <Share2 className="w-7 h-7 text-amber-400" /> Publier
        </h1>
        <p className="text-zinc-500 text-sm mt-1">Publiez une image ou une vidéo sur Facebook, Instagram et TikTok en même temps — avec retry sélectif par réseau.</p>
      </div>
      <SocialPublish />
    </div>
  );
}
